import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, Navbar } from "../components";
import { useSelector, useDispatch } from "react-redux";
import { addCart, delCart } from "../redux/action";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME,Image_Base_Url,ACCESS_Role_ID,ACCESS_Log_In_User_Id } from '../constants/apiConstants';


const CourseCart = () => {
  const state = useSelector((state) => state.handleCart);
  const [shippingType, setShippingType] = useState("flat");
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [course, setCourse] = useState(""); // State to hold course data
  const [cartItems, setCartItems] = useState([]);
  const [courseDetails, setCourseDetails] = useState([]);
  const [createdBy, setCreatedBy] = useState([]);
  const [courseDetailBasedOnUserid, setCourseDetailBasedOnUserid] = useState([]);
  const [createdById, setCreatedById] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
      getCartItems();
  }, []); // Add id as dependency to run effect when id changes
  // const getCartItems = async () => {
  //     const user_id = ACCESS_Log_In_User_Id();
  //     axios.get(`${API_BASE_URL}/cart?user_id=${user_id}`)
  //         .then(function (response) {
  //             // console.log(response.data);
  //             // console.log(response.data.data);
  //             //  console.log(response.data.code);
  //             if (response.data.code == 200) {
  //                 console.log(response.data);
  //                 setCartItems(response.data.data);
  //             }
  //         })
  //         .catch(function (error) {
  //             console.log(error);
  //         });

  // };
  // useEffect(() => {
  //     const fetchCourseDetails = async () => {
  //         setLoading(true);
  //         setError(null);

  //         try {
  //             // Create an array of promises for each product API call
  //             const promises = cartItems.map(item =>
  //                 axios.get(API_BASE_URL + '/getCoursesDetailsById/' + item.courses_details_id)
  //             );

  //             // Wait for all the promises to resolve
  //             const responses = await Promise.all(promises);

  //             // Map the responses to extract product details
  //             const products = responses.map(response => response.data);
  //             console.log(products);
  //             // Set the product details state
  //             setCourseDetails(products);

  //         } catch (err) {
  //             // Handle errors
  //             setError(err.message);
  //         } finally {
  //             setLoading(false);
  //         }
  //     };

  //     fetchCourseDetails();
  // }, [cartItems]); // Run the effect when cartItems changes


  // useEffect(() => {
  //     const fetchCourseDetailBasedOnUserid = async () => {
          
  //         try {
  //             // Create an array of promises for each product API call
  //             const createdBypromisess = courseDetails.map(innerArray => (
  //                 innerArray.map(courses => (
  //                 axios.post(API_BASE_URL+'/getCoursesDetailsByUserId',{'user_id':courses.user_id})
  //                 ))
  //             ));

  //             // Wait for all the promises to resolve
  //             const createdByresponsess = await Promise.all(createdBypromisess);
  //             console.log("+++++++++++++");
  //             console.log(createdByresponses);
  //             console.log("+++++++++++++");
  //             // Map the responses to extract product details
              
  //             const createdByproductss = createdByresponsess.map(createdByresponsess => createdByresponsess.data);
              
  //             console.log(createdByproductss);
  //             //console.log(PromiseResult);
  //             console.log("+++++++++++++");
  //             //const users = createdByproducts.map(createdByproducts => createdByproducts.data);
              
  //             // Set the product details state
  //             setCourseDetailBasedOnUserid(createdByproducts);

  //         } catch (err) {
  //             // Handle errors
  //             setError(err.message);
  //         } finally {
  //             setLoading(false);
  //         }
              
  //     };
  //     const fetchCreatedBy = async () => {
  //         setLoading(true);
  //         setError(null);
  //         try {
  //             // Create an array of promises for each product API call
  //             const createdBypromises = courseDetails.map(innerArray => (
  //                 innerArray.map(courses => (
  //                 axios.get(`${API_BASE_URL}/getCoursesCreatedBy?user_id=${courses.user_id}`)
  //                 ))
  //             ));

  //             // Wait for all the promises to resolve
  //             const createdByresponses = await Promise.all(createdBypromises);
  //             //console.log(createdByresponses);
  //             // Map the responses to extract product details
              
  //             const createdByproducts = createdByresponses.map(createdByresponses => createdByresponses.data);
  //             // console.log("===============");
  //             // console.log(createdByproducts);
  //             // console.log("===============");
  //             //const users = createdByproducts.map(createdByproducts => createdByproducts.data);
              
  //             // Set the product details state
  //             setCreatedBy(createdByproducts);

  //         } catch (err) {
  //             // Handle errors
  //             setError(err.message);
  //         } finally {
  //             setLoading(false);
  //         }
  //     };
  //     fetchCourseDetailBasedOnUserid();
  //     fetchCreatedBy();
  // }, [cartItems]); // Run the effect when cartItems changes


  // const removeFromCart = async (id) => {
  //     const user_id = ACCESS_Log_In_User_Id();
  //     axios.delete(`${API_BASE_URL}/cart/${id}/${user_id}`)
  //         .then(function (response) {

  //             if (response.data.code == 200) {
  //                 //console.log(response.data);
  //                 getCartItems();
  //             }
  //         })
  //         .catch(function (error) {
  //             console.log(error);
  //         });
  // };


  const getCartItems = async () => {
      const user_id = ACCESS_Log_In_User_Id();
      axios
          .get(`${API_BASE_URL}/cart?user_id=${user_id}`, {
              headers: {
                  "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`, // Replace with your actual token
                  "Content-Type": "application/json",
              },
          })
          .then(function (response) {
              if (response.data.code === 200) {
                console.log("Amar");
                  console.log(response.data);
                  setCartItems(response.data.data);
              }
          })
          .catch(function (error) {
              console.error(error);
          });
  };
  
  useEffect(() => {
      const fetchCourseDetails = async () => {
          setLoading(true);
          setError(null);
  
          try {
              const promises = cartItems.map(item =>
                  axios.get(API_BASE_URL + '/getCoursesDetailsById/' + item.courses_details_id, {
                      headers: {
                          "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                          "Content-Type": "application/json",
                      },
                  })
              );
  
              const responses = await Promise.all(promises);
              const products = responses.map(response => response.data);
              console.log("Jain");
              console.log(products);
              setCourseDetails(products);
  
          } catch (err) {
              setError(err.message);
          } finally {
              setLoading(false);
          }
      };
  
      fetchCourseDetails();
  }, [cartItems]);
  
  useEffect(() => {
      const fetchCourseDetailBasedOnUserid = async () => {
          try {
              const createdBypromises = courseDetails.map(innerArray =>
                  innerArray.map(courses =>
                      axios.post(
                          API_BASE_URL + '/getCoursesDetailsByUserId',
                          { user_id: courses.user_id },
                          {
                              headers: {
                                  "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                                  "Content-Type": "application/json",
                              },
                          }
                      )
                  )
              );
  
              const createdByresponses = await Promise.all(
                  createdBypromises.flat()
              ); // Flatten nested promises
              console.log("+++++++++++++");
              console.log(createdByresponses);
              console.log("+++++++++++++");
  
              const createdByproducts = createdByresponses.map(res => res.data);
              console.log(createdByproducts);
  
              setCourseDetailBasedOnUserid(createdByproducts);
  
          } catch (err) {
              setError(err.message);
          } finally {
              setLoading(false);
          }
      };
  
      const fetchCreatedBy = async () => {
          setLoading(true);
          setError(null);
          try {
              const createdBypromises = courseDetails.map(innerArray =>
                  innerArray.map(courses =>
                      axios.get(
                          `${API_BASE_URL}/getCoursesCreatedBy?user_id=${courses.user_id}`,
                          {
                              headers: {
                                  "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                                  "Content-Type": "application/json",
                              },
                          }
                      )
                  )
              );
  
              const createdByresponses = await Promise.all(
                  createdBypromises.flat()
              ); // Flatten nested promises
              const createdByproducts = createdByresponses.map(res => res.data);
  
              setCreatedBy(createdByproducts);
  
          } catch (err) {
              setError(err.message);
          } finally {
              setLoading(false);
          }
      };
  
      fetchCourseDetailBasedOnUserid();
      fetchCreatedBy();
  }, [cartItems]);
  
  const removeFromCart = async (id) => {
      const user_id = ACCESS_Log_In_User_Id();
      axios
          .delete(`${API_BASE_URL}/cart/${id}/${user_id}`, {
              headers: {
                  "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                  "Content-Type": "application/json",
              },
          })
          .then(function (response) {
              if (response.data.code === 200) {
                  getCartItems();
              }
          })
          .catch(function (error) {
              console.error(error);
          });
  };
  
  // Function to calculate total price
  const calculateTotalPrice = () => {
      return cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
  };
  const amount = calculateTotalPrice(); // Example amount
  const handleCheckout = () => {
      // Redirect to checkout with the amount as state
      navigate('/CourseCheckout', { state: { amount } });
    };
  const EmptyCart = () => {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 py-5 bg-light text-center">
            <h4 className="p-3 display-5">Your Cart is Empty</h4>
            <Link to="/" className="btn  btn-outline-dark mx-4">
              <i className="fa fa-arrow-left"></i> Continue Shopping
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const addItem = (product) => {
    dispatch(addCart(product));
  };
  const removeItem = (product) => {
    dispatch(delCart(product));
  };

  const ShowCart = () => {
    let subtotal = 0;
    let shipping = 30.0;
    let totalItems = 0;
    // state.map((item) => {
    //   return (subtotal += item.price * item.qty);
    // });

    // state.map((item) => {
    //   return (totalItems += item.qty);
    // });
    return (
      <>
        <section className="h-100 gradient-custom">
          <div className="container py-5">
            <div className="row d-flex justify-content-center my-4">
              {/* <div className="col-md-8">
                <div className="card mb-4">
                  <div className="card-header py-3">
                    <h5 className="mb-0">Item List</h5>
                  </div>
                  <div className="card-body">
                    {[1].map((item) => {
                      return (
                        <div key={item.id}>
                          <div className="row d-flex align-items-center">
                            <div className="col-lg-3 col-md-12">
                              <div
                                className="bg-image rounded"
                                data-mdb-ripple-color="light"
                              >
                                <img
                                  src={item.image}
                                  // className="w-100"
                                  alt={item.title}
                                  width={100}
                                  height={75}
                                />
                              </div>
                            </div>

                            <div className="col-lg-5 col-md-6">
                              <p>
                                <strong>{item.title}</strong>
                              </p>
                              <p>Color: blue</p>
                              <p>Size: M</p>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div
                                className="d-flex mb-4"
                                style={{ maxWidth: "300px" }}
                              >
                                <button
                                  className="btn px-3"
                                  onClick={() => {
                                    removeItem(item);
                                  }}
                                >
                                  <i className="fas fa-minus"></i>
                                </button>

                                <p className="mx-5">{item.qty}</p>

                                <button
                                  className="btn px-3"
                                  onClick={() => {
                                    addItem(item);
                                  }}
                                >
                                  <i className="fas fa-plus"></i>
                                </button>
                              </div>

                              <p className="text-start text-md-center">
                                <strong>
                                  <span className="text-muted">{item.qty}</span>{" "}
                                  x ${item.price}
                                </strong>
                              </p>
                            </div>
                          </div>

                          <hr className="my-4" />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div> */}

<div className="col-md-8">
  <div
    className="card  shadow-sm d-flex flex-column justify-content-between"
    style={{ borderRadius: "20px", height: "100%" }}
  >
    <div className="card-body">
    
      <div className="d-flex justify-content-between align-items-center mb-3 px-2">
        <div className="fw-bold" style={{ flex: 1 }}>
          Product
        </div>
        <div className="fw-bold text-center" style={{ width: "120px" }}>
          Price
        </div>
        <div className="fw-bold text-center" style={{ width: "340px" }}>
          {/* Quantity */}
        </div>
      </div>
      <hr />

   
      {courseDetails.map((innerArray, i) => (
  innerArray.map(course => (
    <div
      key={course.id}  // Change from item.id to course.id
      className="d-flex align-items-center justify-content-between px-2 mb-3"
    >
      {/* Product */}
      <div className="d-flex align-items-center" style={{ flex: 1 }}>
        {/* <img
          src={`${Image_Base_Url}${course.course_image_path}`}
          width={50}
          height={75}
          className="me-3"
        /> */}
            <img
                                  src={
                                    (() => {
                                      try {
                                        const parsed = JSON.parse(course.course_image_name);
                                        return Array.isArray(parsed)
                                          ? `${Image_Base_Url}${parsed[0]?.image_path}`
                                          : `${Image_Base_Url}${parsed}`;
                                      } catch {
                                        return `${Image_Base_Url}${course.course_image_path || course.course_image_name}`;
                                      }
                                    })()
                                  }
                                  width={50}
                                  height={75}
                                  className="me-3"
                                />
        <span>{course.course_title}</span>
      </div>

      {/* Price */}
      <div className="text-center" style={{ width: "120px" }}>
        ${course.course_price}
      </div>

      {/* Quantity + Remove */}
      <div
        className="d-flex align-items-center justify-content-end gap-3"
        style={{ width: "340px" }}
      >
        {/* Quantity Control */}
        {/* <div
          className="d-flex align-items-center justify-content-between px-3 py-1"
          style={{
            border: "1px solid #dee2e6",
            borderRadius: "50px",
            minWidth: "100px",
          }}
        >
          <button
            className="btn p-0 border-0"
            style={{
              fontSize: "18px",
              color: "#000",
              background: "transparent",
            }}
          >
            −
          </button>
          <span style={{ fontWeight: "500" }}>{course.qty}</span>
          <button
            className="btn p-0 border-0"
            style={{
              fontSize: "18px",
              color: "#000",
              background: "transparent",
            }}
          >
            +
          </button>
        </div> */}

        {/* Remove Button */}
        <button
          className="d-flex align-items-center px-2 py-1"
          style={{
            border: "1px solid black",
            background: "transparent",
            color: "gray",
            fontSize: "14px",
          }}
          onClick={() => removeFromCart(course.id)} >
          × <span className="ms-1">Remove</span>
        </button>
      </div>
    </div>
  ))
))}


      <hr />
      <div className="d-flex flex-column flex-md-row gap-3 justify-content-between align-items-center">
        {/* Coupon Input */}
        <div className="input-group" style={{ maxWidth: "350px" }}>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Coupon Code"
            style={{ borderRadius: "6px 0 0 6px" }}
          />
          <button
            className="btn text-white"
            style={{
              backgroundColor: "#061E45",
              borderRadius: "0 6px 6px 0",
            }}
          >
            Apply
          </button>
        </div>

        {/* Clear Cart Button */}
        {/* <button
          className="btn text-white px-4 py-2"
          style={{
            backgroundColor: "#FF7A00",
            borderRadius: "8px",
            fontWeight: 600,
          }}
        >
          CLEAR CART
        </button> */}
      </div>
    </div>

    {/* Footer: Coupon + Clear Cart */}
    {/* <div className="card-footer bg-white border-0 px-4 pb-4">
     
    </div> */}
  </div>
</div>





              {/* <div className="col-md-4">
                <div className="card mb-4">
                  <div className="card-header py-3 bg-light">
                    <h5 className="mb-0">Order Summary</h5>
                  </div>
                  <div className="card-body">
                    <ul className="list-group list-group-flush">
                      <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
                        Products ({totalItems})<span>${Math.round(subtotal)}</span>
                      </li>
                      <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                        Shipping
                        <span>${shipping}</span>
                      </li>
                      <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 mb-3">
                        <div>
                          <strong>Total amount</strong>
                        </div>
                        <span>
                          <strong>${Math.round(subtotal + shipping)}</strong>
                        </span>
                      </li>
                    </ul>

                    <Link
                      to="/checkout"
                      className="btn btn-dark btn-lg btn-block"
                    >
                      Go to checkout
                    </Link>
                  </div>
                </div>
              </div> */}

<div className="col-md-4">
      <div className="card mb-4 shadow-sm" style={{ borderRadius: "20px", height: "100%"  }}>
        <div className="card-body">
          {/* Subtotal Row */}
          <div className="d-flex justify-content-between mb-3">
            <strong>Subtotal</strong>
            {/* <strong>${subtotal.toFixed(2)}</strong> */}
            <strong>${calculateTotalPrice().toFixed(2)}</strong>
          </div>

          {/* Shipping Label */}
          {/* <p className="mb-2 text-muted" style={{ fontSize: "0.85rem", fontWeight: 600 }}>
            Shipping
          </p> */}

          {/* Flat Rate Shipping Option */}
          {/* <div className="form-check d-flex align-items-center mb-2">
            <input
              className="form-check-input me-2"
              type="radio"
              name="shipping"
              id="flatRate"
              checked={shippingType === "flat"}
              onChange={() => setShippingType("flat")}
              style={{ accentColor: "gray", cursor: "pointer" }}
            />
            <label
              className="form-check-label mb-0"
              htmlFor="flatRate"
              style={{ cursor: "pointer" }}
            >
              Flat rate: $20.00
            </label>
          </div> */}

          {/* Free Shipping Option */}
          {/* <div className="form-check d-flex align-items-center mb-4">
            <input
              className="form-check-input me-2"
              type="radio"
              name="shipping"
              id="freeShipping"
              checked={shippingType === "free"}
              onChange={() => setShippingType("free")}
              style={{ accentColor: "gray", cursor: "pointer" }}
            />
            <label
              className="form-check-label mb-0 text-muted"
              htmlFor="freeShipping"
              style={{ cursor: "pointer" }}
            >
              Free shipping
            </label>
          </div> */}

          {/* Total Row */}
          <div className="d-flex justify-content-between mb-4">
            <strong>Total</strong>
            {/* <strong>${(subtotal + shipping).toFixed(2)}</strong> */}
            <strong>{(calculateTotalPrice()).toFixed(2)}</strong>
          </div>

          {/* Checkout Button */}
          <button
            className="btn w-100 text-white"
            style={{
              backgroundColor: "#FF7A00",
              borderRadius: "12px",
              fontWeight: 600,
            }} onClick={handleCheckout}
          >
            PROCEED TO CHECKOUT &nbsp; →
          </button>
        </div>
      </div>
    </div>

            </div>
          </div>
        </section>
      </>
    );
  };

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        {/* <h1 className="text-center">Cart</h1> */}
        <hr />
       <ShowCart /> 
      </div>
      <Footer />
    </>
  );
};

export default CourseCart;
